import { render, staticRenderFns } from "./EditionFondateurDialog.vue?vue&type=template&id=3dce14d8&"
import script from "./EditionFondateurDialog.vue?vue&type=script&lang=js&"
export * from "./EditionFondateurDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports